import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const integrationsRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Integrations" },
    async lazy() {
      const { Page } = await import("../app/page");
      return {
        element: (
          <Page
            hideHeader={() => false}
            hideNavbar={() => false}
            hidePadding={() => false}
            newChrome
          />
        ),
      };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { IntegrationsOverviewPage } = await import("./pages/overview");
          return { Component: IntegrationsOverviewPage };
        },
      },
    ],
  },
];
